import '@massilia/ui/styles.css'

import './styles.css'
import './index.css'
import { bootstrapAccessToken, clearAccessToken } from '@massilia/queries'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import React from 'react'
import ReactDOM from 'react-dom/client'

import { routeTree } from '@/routeTree.gen'
import { useAuthStore } from '@/stores/auth.store'

const router = createRouter({
  // Remet le scroll en haut lors d'une navigation vers une nouvelle page, tout en
  // conservant la position quand seuls les search params changent (ex : filtres sur
  // la page des résultats de vols, même pathname).
  getScrollRestorationKey: (location) => location.pathname,
  routeTree,
  scrollRestoration: true,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const root = document.getElementById('root')

// Set title with fallback
document.title = import.meta.env.VITE_SITE_NAME ?? 'Massilia Voyages'

async function bootstrapAuthSession() {
  const { isAuthenticated, updateAuth, user } = useAuthStore.getState()

  if (!isAuthenticated || !user) {
    clearAccessToken()
    return
  }

  const accessToken = await bootstrapAccessToken('user')

  if (!accessToken) {
    clearAccessToken()
    updateAuth({
      isAuthenticated: false,
      user: undefined,
    })
    return
  }

  updateAuth({
    isAuthenticated: true,
    user,
  })
}

if (root) {
  void bootstrapAuthSession().finally(() => {
    ReactDOM.createRoot(root).render(
      <React.StrictMode>
        <RouterProvider router={router} />
      </React.StrictMode>
    )
  })
}
